<template>
  <div class="container-content">
    <div class="header">
      <div class="header-title" v-html="$t('connection.request.sent')"></div>
    </div>
    <div class="container-loader">
      <div class="loader"></div>
    </div>
    <div class="actions">
      <p class="text-information">{{ $t('confirm.connection.to.capusta.using.app') }} <a href="https://help.capusta.space/fns/connection" target="_blank">{{ $t('common.instruction') }}</a></p>
      <div class="button-link-container">
        <a href="https://npd.nalog.ru/web-app/" target="_blank">
          <div class="button-link">{{ $t('fns.site') }}</div>
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.gnivts.selfemployed&hl=ru" target="_blank">
          <div class="button-link">{{ $t('for.android') }}</div>
        </a>
        <a href="https://apps.apple.com/ru/app/%D0%BC%D0%BE%D0%B9-%D0%BD%D0%B0%D0%BB%D0%BE%D0%B3/id1437518854?l=en" target="_blank">
          <div class="button-link">{{ $t('for.iphone') }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConnectingSelfEmployed',
};
</script>

<style lang="sass" scoped>
  @keyframes rotateLoader
    100%
      transform: rotate(360deg)

  .container-content
    width: 100%
    padding: 20px 0
    position: relative

    +respond-to("small")
      width: 500px
      margin: 0 auto
      padding: 60px 0

  .header
    display: flex
    justify-content: center
    padding: 0 20px

  .header-title
    align-self: center
    font-size: 20px
    line-height: 24px

    &::deep span
      display: block

      +respond-to("small")
        display: inline

  .container-loader
    position: relative
    max-width: 100%
    width: 265px
    height: 265px
    margin: 0 auto
    display: flex
    justify-content: center
    align-items: center
    overflow: hidden

    +respond-to("small")
      width: 380px
      height: 380px

    &::after
      content: ''
      width: 220px
      height: 220px
      position: absolute
      top: 50%
      right: 0
      bottom: 0
      left: 50%
      background: url("~@/assets/img/self-employed.svg") center 4px / cover no-repeat
      border-radius: 50%
      transform: translate(-50%, -50%)

      +respond-to("small")
        width: 310px
        height: 310px
        background-size: auto

    .loader
      position: relative
      width: 220px
      height: 220px
      background: url("~@/assets/img/self-employed-pending.svg") center center / cover no-repeat
      animation: rotateLoader 3s linear infinite

      +respond-to("small")
        width: 310px
        height: 310px

  .actions
    width: 100%
    margin: 0 auto
    padding: 0 20px

  .button-send
    margin-bottom: 30px

    +respond-to("small")
      margin-bottom: 60px

    button
      width: 100%
      display: block
      margin: 0 auto
      padding: 16px
      font-weight: 600
      font-size: 18px
      line-height: 18px
      border-radius: 2rem
      background-color: #7CB342
      box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25)

      +respond-to("small")
        width: 300px

      &:hover(:not):disabled
        box-shadow: inset 0 -0.24rem 0 rgba(0, 0, 0, 0.2), 0 0.24rem 0.24rem rgba(124, 179, 66, 0.2)

      &:disabled,
      &.disabled
        color: #6b6b76
        background-color: #3a3a49
        cursor: not-allowed

  .text-information
    margin-bottom: 20px
    font-weight: 500
    font-size: 16px
    line-height: 20px
    text-align: center
    color: #fff

    a
      color: #7CB342
      text-decoration: underline

      &:hover
        text-decoration: none

    +respond-to("small")
      margin-bottom: 40px

      span
        display: inline-block

  .button-link-container
    width: 280px
    margin: 0 auto
    display: flex
    flex-flow: row wrap
    justify-content: space-between
    margin-bottom: 20px

    a:last-child
      width: 100%

    a:not(:last-child)
      margin-bottom: 20px

    +respond-to("small")
      width: 100%
      justify-content: space-between

      a:last-child
        width: auto

      a:not(:last-child)
        margin-bottom: 0px

  .button-link
    width: 100%
    min-width: 130px
    max-width: 140px
    margin: 0 auto
    padding: 10px 20px
    text-align: center
    border-radius: 50px
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: #fff
    background: #27283C
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15)
    cursor: pointer

    +respond-to("small")
      width: 140px
</style>
